import React, { useState } from 'react';
import './TweetBox.css';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import db from './firebase';

function TweetBox() {
  const [tweetMessage, setTweetMessage] = useState('');
  const [tweetImage, setTweetImage] = useState('');
  
  const sendTweet = e => {
    e.preventDefault();

    db.collection('posts').add({
      avatar: 'https://avatars.githubusercontent.com/u/93612680?v=4',
      displayName: 'Mallory Shackford',
      username: '@mb_shack',
      verified: true,
      text: tweetMessage,
    });

    setTweetMessage("");
    setTweetImage("");

  }

  return (
    <div className="tweetBox">
    <form>
        <div className="tweetBox_input">
            <Avatar />
            <input 
                onChange={(e) => setTweetMessage(e.target.value)}
                value={tweetMessage}
                placeholder="What's happening?" 
                type="text" 
                />
        </div>
            <input 
                onchange={(e) => setTweetImage(e.target.value)}
                value={tweetImage}
                className="tweetBox_imageInput" 
                placeholder="Optional: Enter image URL" 
                type="text"
                 />

            <Button onClick={sendTweet} type="submit" className="tweetBox_tweetBtn">Tweet</Button>
    </form>
    </div>
  )
}

export default TweetBox